import { render, staticRenderFns } from "./CargaDados.vue?vue&type=template&id=735d6a38&scoped=true&"
import script from "./CargaDados.vue?vue&type=script&lang=ts&"
export * from "./CargaDados.vue?vue&type=script&lang=ts&"
import style0 from "./CargaDados.vue?vue&type=style&index=0&id=735d6a38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735d6a38",
  null
  
)

export default component.exports